import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "../auth";
import { Observable, map } from "rxjs";
import { OfflineDataService } from "./services/offline-data.service";
import { FrontendDiagnosticsService } from "./services/frontend-diagnostics.service";

@Injectable({ providedIn: 'root' })
// protects routes from unauthenticated users
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
    private offlineDataService: OfflineDataService,
    private frontendDiagnosticsService: FrontendDiagnosticsService
  ) {
  }
  
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // Only check if the user is signed in, permission checking is handled separately
    if (this.authService.isSignedIn()) {
      return true;
    }
    
    console.warn('AuthGuard: missing authentication');
    this.frontendDiagnosticsService.addDiagnostic('auth-guard-blocked-navigation', JSON.stringify({
      url: state.url,
      hasTokenInfo: !!this.authService.tokenInfo,
      hasUserInfo: !!this.authService.userInfo,
      tokenExpiresAt: this.authService.tokenInfo?.expires_at ?? '',
      refreshExpiresAt: this.authService.tokenInfo?.refresh_expires_at ?? '',
      offlineMode: this.offlineDataService.isInOfflineMode(),
    }));
    
    //If offline mode, redirect to offline login
    if (this.offlineDataService.isInOfflineMode()) {
      return true;
    }

    // Only redirect to signin if the user is not authenticated
    this.router.navigate(['/auth/signin'], {
      queryParams: { returnUrl: state.url }
    });
    
    return false;
  }
}
